/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Screwoperationhours2Inputs */



/**
* | output |
* | --- |
* | "Screw operation hours" |
*
* @param {Br_History_Key_Screwoperationhours2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_screwoperationhours2 = /** @type {((inputs?: Br_History_Key_Screwoperationhours2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Screwoperationhours2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Screw operation hours")
	return /** @type {LocalizedString} */ ("Heures de fonctionnement de la vis")
});
export { br_history_key_screwoperationhours2 as "br_history_key_screwOperationHours" }